import { AdditionalContentState } from './state';
import * as actions from './actions';
import {CREATE_ADDITIONAL_CONTENT_EVENT_SUCCESS} from './actions';

export type Action = actions.All;
const defaultState = new AdditionalContentState();

export function AdditionalContentReducer(state = defaultState, action: Action): AdditionalContentState {
    switch (action.type) {

      case actions.GET_ADDITIONAL_CONTENT_EVENTS: {
        return {
          ...state,
          result: {
            editDisabled:false,
            deleteDisabled:false,
            saveDisabled:false,
            submitDisabled:false,
            loading: true,
            error: false,
            preSeasonItems: [...state.result.preSeasonItems],
            midSeasonItems: [...state.result.midSeasonItems],
            otherClubItems: [...state.result.otherClubItems],
            trainingGroundItems: [...state.result.trainingGroundItems],
          }
        };
      }

      case actions.GET_ADDITIONAL_CONTENT_EVENTS_SUCCESS: {
        const sortedPreSeason = action.payload.PreSeason.sort((a, b) => a.arrivalUtc.valueOf() > b.arrivalUtc.valueOf() ? 1 : -1);
        const sortedMidSeason = action.payload.MidSeason.sort((a, b) => a.arrivalUtc.valueOf() > b.arrivalUtc.valueOf() ? 1 : -1);
        const sortedClub = action.payload.Club.sort((a, b) => a.arrivalUtc.valueOf() > b.arrivalUtc.valueOf() ? 1 : -1);
        const sortedGround = action.payload.TrainingGround.sort((a, b) => a.arrivalUtc.valueOf() > b.arrivalUtc.valueOf() ? 1 : -1);
        return {
          ...state,
          result: {
            editDisabled:false,
            deleteDisabled:false,
            saveDisabled:false,
            submitDisabled:false,
            loading: false,
            preSeasonItems: sortedPreSeason,
            midSeasonItems: sortedMidSeason,
            otherClubItems: sortedClub,
            trainingGroundItems: sortedGround,
            error: false
          }
        };
      }

      case actions.GET_ADDITIONAL_CONTENT_EVENTS_ERROR: {
        return {
          ...state,
          result: {
            editDisabled:false,
            deleteDisabled:false,
            saveDisabled:false,
            submitDisabled:false,
            loading: false,
            error: true,
            preSeasonItems: [],
            midSeasonItems: [],
            otherClubItems: [],
            trainingGroundItems: []
          }
        };
      }

      case actions.GET_ADDITIONAL_CONTENT_EVENT_BY_ID: {
        return {
           ...state,
           loading: true,
           error: false,
           additionalContentDetails: {
             ...state.additionalContentDetails,
             [action.id]: null
           }
        };
      }
      case actions.GET_ADDITIONAL_CONTENT_EVENT_BY_ID_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: false,
          additionalContentDetails: {
            ...state.additionalContentDetails,
            [action.payload.eventId]: action.payload
          }
        };
      }

      case actions.CREATE_ADDITIONAL_CONTENT_EVENT: {
        return {
          ...state,
          loading: true,
          error: false,
          createdAdditionalContent: ''
        };
      }
      

      case actions.CREATE_ADDITIONAL_CONTENT_EVENT_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: false,
          additionalContentDetails: {
            ...state.additionalContentDetails,
            [action.payload.eventId]: action.payload
          },
          createdAdditionalContent: action.payload.eventId
        };
      }
      

      case actions.UPDATE_ADDITIONAL_CONTENT_EVENT: {
        return {
          ...state,
          loading: true,
          error: false,
          additionalContentDetails: {
            ...state.additionalContentDetails,
            [action.payload.eventId]: null
          }
        };
      }

      case actions.UPDATE_ADDITIONAL_CONTENT_EVENT_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: false,
          additionalContentDetails: {
            ...state.additionalContentDetails,
            [action.payload.eventId]: action.payload
          }
        };
      }

      case actions.CREATE_CLUB_CONTENT_SESSION_REQUEST:
      case actions.UPDATE_CLUB_CONTENT_SESSION_REQUEST: {
        return {
          ...state,
          loading: true,
          error: false
        };
      }

      case actions.CREATE_CLUB_CONTENT_SESSION_REQUEST_SUCCESS:
      case actions.UPDATE_CLUB_CONTENT_SESSION_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: false,
          additionalContentDetails: {
            ...state.additionalContentDetails,
            [action.payload.eventId]: action.payload
          }
        };
      }

      case actions.GET_ADDITIONAL_CONTENT_EVENT_BY_ID_ERROR:
      case actions.CREATE_ADDITIONAL_CONTENT_EVENT_ERROR:
      case actions.UPDATE_ADDITIONAL_CONTENT_EVENT_ERROR:
      case actions.CREATE_CLUB_CONTENT_SESSION_REQUEST_ERROR:
      case actions.UPDATE_CLUB_CONTENT_SESSION_REQUEST_ERROR: {
        return {
          ...state,
          loading: false,
          error: true,
          saveDisabled: false,
          submitDisabled: false,
          editDisabled: false,
          deleteDisabled: false
        };
      }

      default: {
        return state;
      }
    }
}
